//models
import { Tenant } from "models/tenant/tenant";
import React, { FC, useEffect, useMemo, useState } from "react";

import TableContainer from "common/table-container";
import LoadingComponent from "common/components/loader";

import { GetTenantUsers } from "api/tenant";
import { User } from "models/user/user";
import { AppUtility } from "../../../utility/app-utility";
interface Props {
  tenant?: Tenant;
}

const TenantUsersComponent: React.FC<Props> = ({ tenant }) => {
  const [data, setData] = useState<User[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const loadTenantUsers = async () => {
    if (tenant) {
      setLoading(true);
      const res = await GetTenantUsers(
        tenant?.id ?? "",
        {
          userRoles: ["TENANT_ADMIN", "TENANT_MANAGER", "TENANT_STAFF"],
        },
        undefined,
        100,
        1
      );
      if (!(res?.status?.isError ?? false) && res?.data) {
        setData(res?.data ?? []);
        setTotal(res?.totalResultCount ?? 0);
      } else {
        setData([]);
        setTotal(0);
      }
      setLoading(false);
    }
  };

  // Get Data
  useEffect(() => {
    loadTenantUsers();
  }, [tenant]);

  const columns = useMemo(
    () => [
      {
        header: "First Name",
        accessorKey: "firstName",
        enableColumnFilter: false,
      },
      {
        header: "Last Name",
        accessorKey: "lastName",
        enableColumnFilter: false,
      },
      {
        header: "Contact Number",
        accessorKey: "phone",
        enableColumnFilter: false,
      },
      {
        header: "Email",
        accessorKey: "email",
        enableColumnFilter: false,
      },
      {
        header: "Username",
        accessorKey: "username",
        enableColumnFilter: false,
      },
      {
        header: "Role",
        accessorKey: "role",
        enableColumnFilter: false,
        cell: (cell: any) => <>{AppUtility.displayNameForRole(cell.row.original.activeRole)}</>,
      },
    ],
    []
  );

  return (
    <>
      {loading ? (
        <LoadingComponent></LoadingComponent>
      ) : (
        <div className="overflow-x-auto mt-2">
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={true}
              columns={columns || []}
              data={data || []}
              totalCount={total}
              customPageSize={10}
              divclassName="overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:bg-zink-600 dark:text-zink-200"
              thclassName="px-3.5 py-2.5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
            />
          ) : (
            <div className="noresult">
              <div className="py-6 text-center">
                {/*   <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" /> */}
                <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                <p className="mb-0 text-slate-500 dark:text-zink-200">
                  We've searched users matched to your criteria, We did not find any.
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default TenantUsersComponent;
